import React, { FC, useEffect, useState } from 'react';

import * as CSS from '../../match-entry-styles';
import { calculateOveralMatchResult, getResultDisplayColorTextForOverAllResult } from '../../../../utils/score-calculator';

type MatchResultProps = {
  holeIndex: number;
  resultByHole: Array<string>;
};
export const MatchResult: FC<MatchResultProps> = ({ holeIndex, resultByHole }): JSX.Element => {
  const [matchOverAllResult, setMatchOverAllResult] = useState('A/S');

  useEffect(() => {
    setMatchOverAllResult(`${calculateOveralMatchResult(resultByHole.slice(0, holeIndex + 1))} thru ${holeIndex + 1}`);
  }, [resultByHole, holeIndex]);

  return (
    <CSS.MatchResultDisplay>
      {matchOverAllResult.startsWith('--') && <CSS.ArrowLeft />}
      {matchOverAllResult.startsWith('t1') && <CSS.ArrowUp />}
      {matchOverAllResult.startsWith('t2') && <CSS.ArrowDown />}
      <CSS.MatchOverAllResult colour={getResultDisplayColorTextForOverAllResult(matchOverAllResult)}>{matchOverAllResult.substring(3)}</CSS.MatchOverAllResult>
      {matchOverAllResult.startsWith('t1') && <CSS.ArrowUp />}
      {matchOverAllResult.startsWith('t2') && <CSS.ArrowDown />}
      {matchOverAllResult.startsWith('--') && <CSS.ArrowRight />}
    </CSS.MatchResultDisplay>
  );
};
